import { TFunction } from 'i18next'
import * as z from 'zod'

import { ProductPricingModel } from '@features/products/enums/productPricingModel'
import { ProductType } from '@features/products/enums/productType'

import { INTERNAL_NOTE_MAX_LENGTH } from '../../../constants/internalNoteMaxLength'
import { PRODUCT_NAME_MAX_LENGTH } from '../../../constants/productNameMaxLength'
import { ProductEditorFormSchema } from '../../../types/productEditorFormSchema'

const getVatRateSchema = (t: TFunction) =>
  z.object(
    {
      id: z.string().optional(),
      rate: z.number(),
    },
    { message: t('products.creation_modal.errors.vat') },
  )

export const getProductEditorFormSchema = (t: TFunction, isVatExempted: boolean): ProductEditorFormSchema =>
  z.object({
    accountId: z.string().optional(),
    description: z.string().max(INTERNAL_NOTE_MAX_LENGTH).optional(),
    price: z
      .number({ message: t('products.creation_modal.errors.price') })
      .min(0, { message: t('products.creation_modal.errors.price.at_least_zero') }),
    pricingModel: z.nativeEnum(ProductPricingModel),
    productName: z
      .string()
      .max(PRODUCT_NAME_MAX_LENGTH)
      .min(1, { message: t('products.creation_modal.errors.name') }),
    productType: z.nativeEnum(ProductType),
    total: z.number({ message: t('products.creation_modal.errors.price') }),
    unit: z.string({ message: t('external_invoices.editor.form.field.line.field.unit.error.required') }),
    vatRate: isVatExempted ? getVatRateSchema(t).optional() : getVatRateSchema(t),
  })
